// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"951bb1dc","930":"d3d9fce0"}[chunkId] + ".chunk.js";
};